import React from "react";
import { Box, IconButton } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import imgurl from "../assests/images/imgurl";

const DotNavigation = ({ sectionRefs, onDotClick, activeSection }) => {
  return (
    <Box  
      position="fixed"
      top="60%"
      right={16}
      sx={{
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        zIndex: 1000,
        height:300,
        alignItems:'center'
      }}
      className="dotRedirectNavigation"
    >
        
       
      <IconButton className={activeSection?.toUpperCase() == "SECTION0" ? "active" : ""} onClick={() => onDotClick(sectionRefs.section0, 'section0')}>
        <FiberManualRecordIcon />
      </IconButton>
      <IconButton className={activeSection?.toUpperCase() == "SECTION1" ? "active" : ""} onClick={() => onDotClick(sectionRefs.section1, 'section1')}>
        <FiberManualRecordIcon />
      </IconButton>
      <IconButton className={activeSection?.toUpperCase() == "SECTION2" ? "active" : ""} onClick={() => onDotClick(sectionRefs.section2, 'section2')}>
        <FiberManualRecordIcon />
      </IconButton>
      <IconButton className={activeSection?.toUpperCase() == "SECTION3" ? "active" : ""} onClick={() => onDotClick(sectionRefs.section3, 'section3')}>
        <FiberManualRecordIcon />
      </IconButton>
    </Box>
    
  );
};

export default DotNavigation;
